import { connect } from 'react-redux';
import { dataWarehouseSelectors } from '@lifesize/nucleus';
import actions from 'actions/drilldownActions';
import { Global } from 'state/Global';
import { parseUserUsageDrillDownDataForExport } from 'utils/exportUtils';
import { exportToCsv } from 'utils/csv-utils';
import intl from 'react-intl-universal';
import UsageDetails from 'components/Drilldowns/UsersAndVideo/UsageDetails';

function mapStateToProps(state: Global) {
  const usersData = dataWarehouseSelectors.usageDetailsForUser(state);
  const records = usersData.data;

  const handleExportToCsv = () => {
    const exportData = [];
    for (let record of records) {
      exportData.push(parseUserUsageDrillDownDataForExport(record));
    }
    exportToCsv(intl.get('csvExportUsageDetailsUser'), exportData);
  };

  return {
    error: usersData.error,
    isFetching: usersData.isFetching,
    records,
    handleExportToCsv
  };
}

const mapDispatchToProps = (dispatch: Function) => ({
  fetchUserData: (config: object) => {
    dispatch(actions.handleFetchUsageDetailsUser(config));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(UsageDetails);
